export default "__VITE_ASSET__394f4dde__"